var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGototop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.513,
    height: 32.512,
    viewBox: "0 0 32.513 32.512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6963",
    "data-name": "Path 6963",
    d: "M9.287,27.116l14.948.277a1.6,1.6,0,0,1,.28.031,1.306,1.306,0,0,1,.88,1.705,1.278,1.278,0,0,1-1.02.767,1.044,1.044,0,0,1-.141.008L6.256,29.627h-.07a1.03,1.03,0,0,1-.139-.016,1.284,1.284,0,0,1-1.039-1.1A1.3,1.3,0,0,1,5,28.371l.277-17.979a1.3,1.3,0,0,1,1.737-1.16,1.284,1.284,0,0,1,.767,1.02,1.319,1.319,0,0,1,.008.141L7.512,25.34l18.5-17.912a2.436,2.436,0,0,1,.22-.175,1.291,1.291,0,0,1,1.854.648,1.269,1.269,0,0,1-.122,1.083,2.467,2.467,0,0,1-.176.221L9.287,27.116Z",
    transform: "translate(41.052 17.61) rotate(135)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGototop);
export default __webpack_public_path__ + "static/media/gototop.b374eb7e7518716588224c9dd560e6a6.svg";
export { ForwardRef as ReactComponent };